import {
  ParameterOperator,
  ParameterOperatorWrapper,
  ParameterText,
} from './ParameterOperators.styles';

interface Props {
  firstColumn: number;
  secondColumn: number;
  isFirstParameter?: boolean;
  isLastParameter?: boolean;
  showOperators?: boolean;
}

export const ParameterOperators = ({
  firstColumn,
  secondColumn,
  isFirstParameter,
  isLastParameter,
  showOperators,
}: Props) => {
  if (isFirstParameter) {
    return (
      <>
        <ParameterText column={firstColumn}>Parameter</ParameterText>
        <ParameterText column={secondColumn}>Is</ParameterText>
        {showOperators ? (
          <ParameterOperatorWrapper isLastParameter={false}>
            <ParameterOperator>If</ParameterOperator>
          </ParameterOperatorWrapper>
        ) : null}
      </>
    );
  }

  return (
    <>
      <ParameterText $end showOperators={showOperators} column={firstColumn}>
        Parameter
      </ParameterText>
      <ParameterText $end showOperators={showOperators} column={secondColumn}>
        Is
      </ParameterText>
      {showOperators ? (
        <ParameterOperatorWrapper isLastParameter={isLastParameter}>
          <ParameterOperator>And</ParameterOperator>
        </ParameterOperatorWrapper>
      ) : null}
    </>
  );
};
